import { ref } from "vue";
import { useRouter } from "vue-router";

export default function useIsInitialPageLoad() {
    const isInitialPageLoad = ref(true);
    const router = useRouter();
    // We're working here with premise that if user navigates from unknown router path name the page is loaded for the first time (counts with page reloads)
    router.beforeEach((to, from, next) => {
        const entries = performance.getEntriesByType("navigation");
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
        isInitialPageLoad.value =
            from.name === undefined && !entries.some((entry: PerformanceNavigationTiming) => entry.type === "reload");
        next();
    });
    return {
        isInitialPageLoad,
    };
}
